// @ts-strict-ignore
export function incrementSaveAsNewReportName(currentReportName: string): string {
  // if we want to capture last digits w/ 1or2 chars after: \\d+(?=[\\W]?$)
  const lastNumberString = currentReportName.match(`\\d+$`)?.[0];
  const endingNumber = parseInt(lastNumberString, 10);
  if (isNaN(endingNumber)) {
    return `${currentReportName} 1`;
  }
  return `${currentReportName.slice(0, -lastNumberString.length)}${endingNumber + 1}`;
}
